<template>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    @input="checkOpen"
  >
    <v-list-group
      v-model="activeUserMenu"
      no-action
      v-if="$store.state.user"
      class="text-center"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title v-text="$store.state.user.username"></v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item v-for="(item, index) in text.pages.userMenu" :key="index" class="text-left">
        <v-list-item-title v-text="item.name" @click="$router.push(item.link)"/>
      </v-list-item>
      <v-list-item-action>
        <v-btn x-small @click="logout">
          {{ text.buttons.logout }}
        </v-btn>
      </v-list-item-action>
    </v-list-group>
    <v-list-item>
      <v-list-item-content v-if="!$store.state.user">
        <v-btn x-small @click="showLogin=true" v-if="!showLogin">
          {{ text.buttons.login }}
        </v-btn>
        <UserLoginFormMobile v-if="showLogin"/>
      </v-list-item-content>
    </v-list-item>
    <v-divider/>
    <MobileMenuList/>
  </v-navigation-drawer>
</template>

<script>
import MobileMenuList from '@/components/Partials/TopBar/MobileMenuList.vue';
import { translations } from '@/lang/translations';
import UserLoginFormMobile from '@/components/Partials/UserLoginFormMobile.vue';
import store, { state } from '../../../store/index';

export default {
  name: 'MobileMenu',
  components: {
    UserLoginFormMobile, MobileMenuList,
  },
  data() {
    return {
      activeUserMenu: false,
      showLogin: false,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' },
      ],
    };
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
    drawer: {
      get: () => state.showMobileMenu,
      set: (newValue) => newValue,
    },
  },
  methods: {
    checkOpen(v) {
      if (!v) {
        store.commit('setShowMobileMenu', false);
      }
    },
    logout() {
      sessionStorage.removeItem(btoa('user'));
      this.$store.commit('loginUser', null);
    },
  },
};
</script>

<style scoped>

</style>
